import React from 'react';
import Dropdown from 'react-dropdown';
import {
    initializeMidiEffect,
    midiEffectOptions,
    midiConditionalOptions,
    effectOptions,
    initializeEffect
} from './constants.js';

export default function EffectDropdown({sequencerEngine, track, isMidiEffect, handleChooseEffect, options, placeholder}) {
    const onChange = (name) => {
        var effect = isMidiEffect ?
            initializeMidiEffect(name, track) :
            initializeEffect(name, sequencerEngine);
        handleChooseEffect(effect);
    };

    let _options = options ? options : isMidiEffect ? midiEffectOptions : effectOptions;
    return (
        <div>
          <Dropdown
            className='effect-dropdown'
            options={_options}
            onChange={(o) => onChange(o.value)}
            placeholder={placeholder || "Add FX"}/>
        </div>
    );
}
